<template>
  <div
    ref="resizableDiv"
    :style="containerStyle"
  >
    <div
      class="resize-handle"
      draggable
      @dragstart="onDragstart"
      @dragend="onDragend"
    />
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    w: {
      type: [Number, String],
      default: '50%'
    },
    maxW: {
      type: [Number, String],
      default: '75%'
    },
    minW: {
      type: [Number, String],
      default: '25%'
    }
  },

  data () {
    return {
      containerWidth: null,
      parent: null
    }
  },

  computed: {
    containerStyle () {
      return {
        width: this.containerWidth,
        borderLeft: '1px dotted gray',
        overflow: 'auto',
        position: 'relative'
      }
    }
  },

  created () {
    if (typeof this.w === 'number') {
      this.containerWidth = this.w + 'px'
    } else {
      this.containerWidth = this.w
    }
  },

  mounted () {
    this.parent = this.$refs.resizableDiv.parentElement
    this.parent && this.parent.addEventListener('dragover', this.onParentDragover)
  },

  beforeDestroy () {
    this.parent && this.parent.removeEventListener('dragover', this.onParentDragover)
  },

  methods: {
    parentPercent (percentage) {
      const parentWidth = this.$refs.resizableDiv.parentElement.clientWidth
      return parentWidth * parseInt(percentage) / 100
    },

    onDragstart (e) {
      e.dataTransfer.effectAllowed = 'move'
    },

    onDragend (e) {
      const offsetX = e.offsetX
      const maxWidth = this.maxW === 'number' ? this.maxW : this.parentPercent(this.maxW)
      const minWidth = this.minW === 'number' ? this.minW : this.parentPercent(this.minW)

      let nextWidth = this.$refs.resizableDiv.clientWidth - offsetX
      if (nextWidth > maxWidth) {
        nextWidth = maxWidth
      } else if (nextWidth < minWidth) {
        nextWidth = minWidth
      }

      this.containerWidth = nextWidth + 'px'
    },

    onParentDragover (e) {
      e.preventDefault()
      e.dataTransfer.dropEffect = 'move'
    }
  }
}
</script>
<style>
  .resize-handle {
    position: absolute;
    height: 100%;
    width: 5px;
    left: 0;
    cursor: col-resize;
  }
</style>
